














import { Component, Vue } from "vue-property-decorator";
import MailCallbackService from "@/services/MailCallbackService";
import { MailCallbackRequestForUserPrompt, MailCallbackType } from "@/dto/mail/callback/MailCallback";
import CreateSubscriptionMailCallback from "@/components/callbacks/CreateSubscriptionMailCallback.vue";
import SalesOrderPaymentMailCallback from "@/components/callbacks/SalesOrderPaymentMailCallback.vue";

@Component({
  components: {
    CreateSubscriptionMailCallback,
    SalesOrderPaymentMailCallback
  }
})
export default class MailCallbackWrapper extends Vue {
  loading = true;
  error: string | null = null;
  requestData: MailCallbackRequestForUserPrompt | null = null;

  mounted() {
    this.getCallbackData();
  }

  async getCallbackData(){
    this.$loadOn()
    if (!this.token) {
      this.$nts.error("###No token")
      return;
    }
    try {
      const response = await MailCallbackService.callCallback(this.token);

      // If the response is a direct success without prompt (MailCallbackCallResponse format)
      if (!('callbackType' in response.data)) {
        this.handleDirectSuccess(response.data.params);
        return;
      }
      // Otherwise it's a prompt
      this.requestData = response.data as MailCallbackRequestForUserPrompt;
    } catch (e: any) {
      console.error("Error loading callback", e);
      this.error = e.response?.data?.message || this.$t('callback.error_loading') as string || "An error occurred while loading this page.";
    } finally {
      this.$loadOff();
    }
  }

  get token(): string {
    return this.$route.query.pid as string;
  }

  get callbackComponent() {
    if (!this.requestData) return null;
    
    switch (this.requestData.callbackType) {
      case MailCallbackType.CREATE_SUBSCRIPTION:
        return 'CreateSubscriptionMailCallback';
      case MailCallbackType.SALES_ORDER_PAYMENT:
        return 'SalesOrderPaymentMailCallback';
      default:
        this.error = `Unknown callback type: ${this.requestData.callbackType}`;
        return null;
    }
  }

  handleDirectSuccess(params: Record<string, any>) {
    if (params.approveLink) {
      window.location.href = params.approveLink;
    } else {
      // Redirect to home if no specific link is provided
      this.$router.push('/');
    }
  }

  handleSuccess(approveLink: string) {
    if (approveLink) {
      window.location.href = approveLink;
    } else {
      this.$router.push('/');
    }
  }
}
